import { render } from "./esco-conversa-em-andamento-order.vue?vue&type=template&id=2ae058ee&scoped=true"
import script from "./esco-conversa-em-andamento-order.vue?vue&type=script&lang=js"
export * from "./esco-conversa-em-andamento-order.vue?vue&type=script&lang=js"

import "./esco-conversa-em-andamento-order.vue?vue&type=style&index=0&id=2ae058ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae058ee"]])

export default __exports__